import { lazy } from 'react';

export const ReimbursementRegistryViewPage = lazy(
  () =>
    import(
      /* webpackPreload: true */
      /* webpackChunkName: "ReimbursementRegistryViewPage" */
      './ReimbursementRegistryViewPage'
    ),
);
